import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = ""

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    {
      key: "exists_email_sales_order_dispatch",
      label: "",
      sortable: true,
      type: "email_state_icon",
      width: "30px",
      thStyle: { width: "30px" },
    },
    {
      key: "SalesId",
      label: "销售订单编号",
      sortable: true,
      width: "100px"
    },
    {
      key: "SalesPoolId",
      label: "池",
      width: "100px"
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "CustAccount",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "SalesName",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "LineNum",
      label: "行号",
      sortable: true,
      width: "40px"
    },
    {
      key: "id",
      label: "派发编号",
      sortable: true,
      width: "40px"
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "Approver",
      label: "当前审批人",
      sortable: true
    },
    {
      key: "fcCheckDocumentAllApproved",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckDocumentAllApproved",
      other_type_key: "is_email_send",
      isCheckInApprove: true,
      context: ["待审批", "已审批", "审批中", "已退回"]
    },
    {
      key: "ApproveRemark",
      label: "当前审批意见",
      sortable: false,
      editable: true,
      type: "textarea"
    },

    {
      key: "Up_Approver",
      label: "前一级审批人",
      sortable: true
    },
    {
      key: "UpApproveRemark",
      label: "审批意见",
      sortable: true,
      width: "12rem",
      type: "html"
    },

    {
      key: "isAXError",
      label: "异常状态",
      sortable: true,
      type: "state_error",
      context: ["", "异常"]
    },
    {
      key: "AXError",
      label: "异常信息",
      sortable: true,
      type: "short",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "SEI_ShippingDateCust",
      label: "客户交期",
      sortable: true,
      type: "date"
    },
    {
      key: "SalesQty",
      label: "数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "valid_remain",
      label: "剩余派单数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "TaxGroup",
      label: "销售税组",
      sortable: true
    },
    {
      key: "SalesPrice",
      label: "销售订单价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "Sales_Order_Price",
      label: "销售订单本币净单价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "CurrencyCode",
      label: "销售订单币种",
      sortable: true
    },
    {
      key: "ConfirmedDlv",
      label: "装运日期",
      sortable: true,
      type: "date"
    },
    {
      key: "SalesUnit",
      label: "单位",
      sortable: true
    },

    {
      key: "TaxItemGroup",
      label: "销售税(物料)组",
      sortable: true
    },
    {
      key: "TEC_CommonRemark",
      label: "通用备注",
      sortable: true,
      thStyle: { width: "10rem" },
      width: "10rem",
      type: "short"
    },
    {
      key: "Name",
      label: "备注",
      sortable: true
    },
    {
      key: "TEC_CustSalesID",
      label: "客户订单号",
      sortable: true
    },
    {
      key: "SEI_OrderDateCust",
      label: "客户订单日期",
      sortable: true,
      type: "date"
    },
    // {
    //   key: "SEI_PriceUnitCust",
    //   label: "客户价格",
    //   sortable: true
    // },
    {
      key: "fcCheckSOAllApproved",
      label: "订单审批状态",
      sortable: true,
      type: "state",
      state_control: "fcCheckSOAllApproved",
      context: ["待审批", "已审批"]
    },
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "11rem"
      }
    },
    {
      key: "qty",
      label: "派发数量",
      type: "number"
      // _precise: 6
    },
    {
      key: "price",
      label: "实际含税价",
      type: "number"
    },
    {
      key: "PurchCurrencyCode",
      label: "实际含税价币种"
    },
    {
      key: "price_wotax",
      label: "实际采购本币净单价",
      type: "number",
      _precise: 6
    },
    {
      key: "price_remark",
      label: "价格备注",
      width: "8rem",
      type: "short"
    },
    {
      key: "price_vend",
      label: "初始含税报价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "price_vend_currency",
      label: "初始含税报价币种",
    },
    {
      key: "price_vend_wotax",
      label: "初始采购本币净单价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "VendTaxGroup",
      label: "供应商税组",
      sortable: true
    },
    {
      key: "quote_state",
      label: "价格状态",
      sortable: true,
      type: "state_icon"
    },
    {
      key: "Cost_Sum",
      label: "供应商成本",
      type: "number"
    },
    {
      key: "Sales_Cost",
      label: "价格协议成本",
      type: "number"
    },
    {
      key: "profit_state",
      label: "毛利状态",
      sortable: true,
      type: "state_icon"
    },
    {
      key: "profit_value",
      label: "毛利",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "invent_sum",
      label: "现有库存量",
      type: "number",
      _precise: 6
    },
    {
      key: "delivery_date",
      label: "装运日期",

      type: "date"
    },
    {
      key: "Capacity",
      label: "产能(天)",

      type: "number"
    },
    {
      key: "RetailVariantId",
      label: "变形编号",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    },

    {
      key: "TotalScore",
      label: "评价",
      sortable: true,
      type: "rate",
      disabled: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "PreDistributRate",
      label: "预分配比例(%)",
    },
    {
      key: "DistributionRateChangedDes",
      label: "比例变更描述",
      type: "textarea"
    },
    {
      key: 'Accessory',
      label: '附件',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    },
    {
      key: "create_at",
      label: "派单时间",
      type: "datetime"
    },
    {
      key: "sd_create_by_username",
      label: "订单创建人",
      sortable: true
    },
    {
      key: "update_by",
      label: "修改人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      sortable: true,
      type: "datetime"
    }
  ]
}

///前端验证
const rules = {}

const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
const methods = {
  async getData(_params) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_so_item_dispatch",
      {},
      {}
    )
    let _fields = []

    let result = await code_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()
    //
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  }
}
export { biz_data, fields, methods, rules };

